/*
 * The side bar components & submenuSidebar components english translation
 */
export const SIDEBAR_COMPONENT_EN = {
  navigation: 'Navigation',
  home: 'Home',
  editor: 'Editor',
  cookingpot: 'Cooking Pot',
  library: 'Archive',
  prompts: 'Prompts',
  liveContent: 'Content Database',
  audioBatch: 'Audio Batch',
  adminScopes: 'Admin Scopes',
  startTheTour: 'Start the Tour!',
  startVideo: 'Watch Tutorial',
  settings: 'Settings',
  accountSettings: 'User Settings',
  organisation: 'Organisation',
  billingOverview: 'Billing Overview',
  logOut: 'Log out',
  chiefEditor: 'Chief Editor',
  organisations: 'Organisations',
  users: 'Users',
  adminDashboard: 'Admin Dashboard',
  searchLibrary: 'Search archive...',
  noResults: 'No results...',
  organisationDetails: 'Organisation Details',
  profile: 'Profile',
  welcomeBack: 'Welcome Back',
  quickstart: 'Quickstart',
  toAllFunctions: 'to all functions...',
  contentDashboard: 'Content Dashboard',
  organisationSettings: 'Organisation Settings',
  openEditor: 'Open Editor',
  jumpBackIn: 'Jump back in',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  noRecentWork: 'No recent work yet',
  homeQuickToolsTab: 'Quick tools',
  homeRecentTab: 'Recent',
  homeResearchPlaceholder: 'Ask me anything to start researching...',
  homeResearchHint: 'Start a research chat instantly. Press Enter to send.',
  homeResearchUnavailable: 'Research chat is available only for beta access accounts.',
  homeEditorCardDescription:
    'Powerful editor that combines AI features in one place to generate high-quality text.',
  homeImageStudioDescription: 'Generate images, your imagination is the limit.',
  homeHeartbeatDescription: 'Create an automated agent that handles your research.',
  betaFeatureTeaser: 'This feature is in beta. Contact sales to request access.',
  betaBadge: 'Beta',
  openNavigationSearch: 'Open navigation search',
  sidebarSheetDescription: 'Sidebar navigation drawer',
  sidebarSheetTitle: 'Navigation menu',
  hoursAgo: '{count} hours ago',
  yesterday: 'Yesterday',
  daysAgo: '{count} days ago',
  customizations: 'Customizations',
  scopes: 'Scopes',
  models: 'Feature TPrompts',
  liveContentSources: 'Live Content Sources',
  onboardingFlows: 'Onboarding Flows',
  userStyles: 'Onboarding Questionnaires',
  pathRestrictions: 'API Restrictions',
  salesDashboard: 'Sales Dashboard',
  researchChatStatistics: 'Research Chat Analytics',
  trialEndsIn: 'Your free trial ends in',
  Trialdays: 'days',
  Trialday: 'day',
  trialExpired: 'Your free trial has expired',
  trialExtend: 'Extend',
  languageSettings: 'Language Settings',
  orgaCustomizationSection: 'Customization',
  activeLanguages: 'Active Languages',
  availableLanguages: 'Available Languages',
  noLanguagesSelected: 'No languages selected',
  allLanguagesAdded: 'All available languages have been added',
  languagesSaved: 'Languages saved successfully',
  errorLoadingLanguages: 'Failed to load languages',
  errorSavingLanguages: 'Failed to save languages',
  saving: 'Saving...',
  save: 'Save',
  styleSettings: 'Style Settings',
  currentStyles: 'Current Styles',
  availableStyles: 'Available Styles',
  createNewStyle: 'Create New Style',
  styleName: 'Style Name',
  styleDescription: 'Style Description',
  styleContent: 'Style Content',
  describeYourStyle: 'Describe the writing style you want...',
  enterStyleContent: 'Enter the style content...',
  generateWithAI: 'AI Generate',
  manualEntry: 'Manual',
  examples: 'Examples',
  examplesPlaceholder: 'Paste example texts that represent this style...',
  generatedResult: 'Generated Result',
  changeRequests: 'Change Requests',
  changeRequestsPlaceholder: 'Describe the changes you want to make...',
  updateStyle: 'Update Style',
  addStyle: 'Add Style',
  noStylesConfigured: 'No styles configured',
  allStylesAdded: 'All available styles have been added',
  stylesSaved: 'Styles saved successfully',
  errorLoadingStyles: 'Failed to load styles',
  errorSavingStyles: 'Failed to save styles',
  errorGeneratingStyle: 'Failed to generate style',
  assistant: 'Chat',
  assistantDescription: 'Unified research and in-app help chat',
  researchChat: 'Research Chat',
  researchChatDescription: 'Chat with AI to research topics',
  fileProcessing: 'File Processing',
  newChat: 'New Chat',
  sendMessage: 'Send message',
  typeMessage: 'Type your message...',
  noSessions: 'No chat sessions yet',
  startNewChat: 'Start a new chat to begin researching',
  deleteSession: 'Delete session',
  confirmDelete: 'Are you sure you want to delete this session?',
  archiveDeleteSessionConfirm: 'Remove this session from archive?',
  archiveDeleteEntryConfirm: 'Remove this entry from archive?',
  archiveSessionDeleted: 'Session removed from archive.',
  archiveEntryDeleted: 'Entry removed from archive.',
  archiveDeleteFailed: 'Failed to delete archive item. Please try again.',
  delete: 'Delete',
  webSearchEnabled: 'Web search enabled',
  webSearchDisabled: 'Web search disabled',
  sessions: 'Sessions',
  untitledChat: 'Untitled Chat'
}
/*
 * The side bar components & submenuSidebar components german translation
 */
export const SIDEBAR_COMPONENT_DE = {
  navigation: 'Navigation',
  home: 'Home',
  editor: 'Editor',
  cookingpot: 'Kochtopf',
  library: 'Archiv',
  prompts: 'Prompts',
  liveContent: 'Content Datenbank',
  audioBatch: 'Audio-Batch',
  adminScopes: 'Admin-Panel',
  startTheTour: 'Tour starten!',
  startVideo: 'Tutorial ansehen',
  settings: 'Einstellungen',
  accountSettings: 'Nutzereinstellungen',
  organisation: 'Organisation',
  billingOverview: 'Abrechnungsübersicht',
  logOut: 'Abmelden',
  chiefEditor: 'Chefredakteur',
  organisations: 'Organisationen',
  users: 'Nutzer',
  adminDashboard: 'Admin Dashboard',
  searchLibrary: 'Archiv durchsuchen...',
  noResults: 'Keine Ergebnisse...',
  organisationDetails: 'Organisationsdetails',
  profile: 'Profil',
  welcomeBack: 'Willkommen Zurück',
  quickstart: 'Quickstart',
  toAllFunctions: 'zu allen Funktionen...',
  contentDashboard: 'Content Dashboard',
  organisationSettings: 'Organisations Einstellungen',
  openEditor: 'Editor öffnen',
  jumpBackIn: 'Zuletzt bearbeitet',
  goodMorning: 'Guten Morgen',
  goodAfternoon: 'Guten Tag',
  goodEvening: 'Guten Abend',
  noRecentWork: 'Noch keine Projekte',
  homeQuickToolsTab: 'Schnellzugriff',
  homeRecentTab: 'Zuletzt',
  homeResearchPlaceholder: 'Stellen Sie eine Frage, um die Recherche zu starten...',
  homeResearchHint: 'Starten Sie sofort einen Recherche-Chat. Enter zum Senden.',
  homeResearchUnavailable: 'Der Recherche-Chat ist nur für Konten mit Beta-Zugang verfügbar.',
  homeEditorCardDescription:
    'Leistungsstarker Editor, der KI-Funktionen an einem Ort bündelt, um hochwertige Texte zu erstellen.',
  homeImageStudioDescription: 'Generiere Bilder, deiner Fantasie sind keine Grenzen gesetzt.',
  homeHeartbeatDescription:
    'Erstelle einen automatisierten Agenten, der deine Recherche übernimmt.',
  betaFeatureTeaser:
    'Diese Funktion ist in der Beta. Kontaktieren Sie den Vertrieb, um Zugang anzufragen.',
  betaBadge: 'Beta',
  openNavigationSearch: 'Navigationssuche öffnen',
  sidebarSheetDescription: 'Seitenleisten-Navigationsbereich',
  sidebarSheetTitle: 'Navigationsmenü',
  hoursAgo: 'vor {count} Stunden',
  yesterday: 'Gestern',
  daysAgo: 'vor {count} Tagen',
  customizations: 'Customizations',
  scopes: 'Scopes',
  models: 'Feature TPrompts',
  liveContentSources: 'Live Content Sources',
  onboardingFlows: 'Onboarding Flows',
  userStyles: 'Onboarding Questionnaires',
  pathRestrictions: 'API Restrictions',
  salesDashboard: 'Sales Dashboard',
  researchChatStatistics: 'Research-Chat-Analysen',
  trialEndsIn: 'Ihre kostenlose Testphase endet in',
  Trialdays: 'Tagen',
  Trialday: 'Tag',
  trialExpired: 'Ihre kostenlose Testphase ist abgelaufen',
  trialExtend: 'Jetzt upgraden',
  languageSettings: 'Spracheinstellungen',
  orgaCustomizationSection: 'Anpassungen',
  activeLanguages: 'Aktive Sprachen',
  availableLanguages: 'Verfügbare Sprachen',
  noLanguagesSelected: 'Keine Sprachen ausgewählt',
  allLanguagesAdded: 'Alle verfügbaren Sprachen wurden hinzugefügt',
  languagesSaved: 'Sprachen erfolgreich gespeichert',
  errorLoadingLanguages: 'Fehler beim Laden der Sprachen',
  errorSavingLanguages: 'Fehler beim Speichern der Sprachen',
  saving: 'Speichern...',
  save: 'Speichern',
  styleSettings: 'Stileinstellungen',
  currentStyles: 'Aktuelle Stile',
  availableStyles: 'Verfügbare Stile',
  createNewStyle: 'Neuen Stil erstellen',
  styleName: 'Stilname',
  styleDescription: 'Stilbeschreibung',
  styleContent: 'Stilinhalt',
  describeYourStyle: 'Beschreiben Sie den gewünschten Schreibstil...',
  enterStyleContent: 'Geben Sie den Stilinhalt ein...',
  generateWithAI: 'KI-Generierung',
  manualEntry: 'Manuell',
  examples: 'Beispiele',
  examplesPlaceholder: 'Fügen Sie Beispieltexte ein, die diesen Stil repräsentieren...',
  generatedResult: 'Generiertes Ergebnis',
  changeRequests: 'Änderungswünsche',
  changeRequestsPlaceholder: 'Beschreiben Sie die gewünschten Änderungen...',
  updateStyle: 'Stil aktualisieren',
  addStyle: 'Stil hinzufügen',
  noStylesConfigured: 'Keine Stile konfiguriert',
  allStylesAdded: 'Alle verfügbaren Stile wurden hinzugefügt',
  stylesSaved: 'Stile erfolgreich gespeichert',
  errorLoadingStyles: 'Fehler beim Laden der Stile',
  errorSavingStyles: 'Fehler beim Speichern der Stile',
  errorGeneratingStyle: 'Fehler beim Generieren des Stils',
  assistant: 'Chat',
  assistantDescription: 'Vereinter Recherche- und In-App-Hilfe-Chat',
  researchChat: 'Recherche Chat',
  researchChatDescription: 'Chatten Sie mit KI, um Themen zu recherchieren',
  fileProcessing: 'Dateiverarbeitung',
  newChat: 'Neuer Chat',
  sendMessage: 'Nachricht senden',
  typeMessage: 'Nachricht eingeben...',
  noSessions: 'Noch keine Chat-Sitzungen',
  startNewChat: 'Starten Sie einen neuen Chat, um mit der Recherche zu beginnen',
  deleteSession: 'Sitzung löschen',
  confirmDelete: 'Sind Sie sicher, dass Sie diese Sitzung löschen möchten?',
  archiveDeleteSessionConfirm: 'Diese Sitzung aus dem Archiv entfernen?',
  archiveDeleteEntryConfirm: 'Diesen Eintrag aus dem Archiv entfernen?',
  archiveSessionDeleted: 'Sitzung aus dem Archiv entfernt.',
  archiveEntryDeleted: 'Eintrag aus dem Archiv entfernt.',
  archiveDeleteFailed: 'Archivobjekt konnte nicht gelöscht werden. Bitte erneut versuchen.',
  delete: 'Löschen',
  webSearchEnabled: 'Websuche aktiviert',
  webSearchDisabled: 'Websuche deaktiviert',
  sessions: 'Sitzungen',
  untitledChat: 'Unbenannter Chat'
}
